export type TreatmentRightValidationInput = {
  treatmentRightCode: string | number | null | undefined
  treatmentRightName: string | number | null | undefined
  price: string | number | null | undefined
  unit: string
  amount: string | number | null | undefined
}

export type TreatmentRightValidationErrors = {
  code?: string
  name?: string
  price?: string
  amount?: string
}

export const normalizeTreatmentRightPrice = (
  price: string | number | null | undefined,
  unit: string
): string | number | null | undefined => {
  if (unit !== 'PERCENT' || price === null || price === undefined || price === '') return price

  const numericPrice = Number(price)
  if (Number.isNaN(numericPrice)) return price

  return numericPrice > 100 ? 100 : price
}

export const getTreatmentRightValidationErrors = ({
  treatmentRightCode,
  treatmentRightName,
  price,
  unit,
  amount
}: TreatmentRightValidationInput): TreatmentRightValidationErrors => {
  const errors: TreatmentRightValidationErrors = {}

  if (!treatmentRightCode) errors.code = 'TREATMENT_RIGHT_CODE'
  if (!treatmentRightName) errors.name = 'TREATMENT_RIGHT_NAME'

  const numericPrice = Number(price)
  if (price === null || price === undefined || price === '' || numericPrice === 0 || Number.isNaN(numericPrice)) {
    errors.price = 'TREATMENT_RIGHT_PRICE'
  } else if (unit === 'PERCENT' && numericPrice > 100) {
    errors.price = 'TREATMENT_RIGHT_PRICE_MAXIMUM'
  }

  const numericAmount = Number(amount)
  if (amount === null || amount === undefined || amount === '' || numericAmount <= 0 || Number.isNaN(numericAmount)) {
    errors.amount = 'TREATMENT_RIGHT_AMOUNT_MINIMUM'
  }

  return errors
}
